<template>
  <RecordViewWrapper>
    <sdPageHeader title="Kontrak Kinerja Organisasi" />
    <Main>
      <!-- Filter Section -->
      <a-row :gutter="15">
        <a-col :sm="24" :xs="24">
          <sdCards headless>
            <a-row :gutter="16">
              <a-col :md="8" :sm="24">
                <a-select
                  placeholder="Pilih Tahun"
                  style="width: 100%"
                  v-model:value="filters.tahun"
                  @change="refreshData"
                >
                  <a-select-option v-for="tahun in tahunOptions" :key="tahun" :value="tahun">
                    {{ tahun }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-select
                  placeholder="Pilih Entitas"
                  style="width: 100%"
                  v-model:value="filters.entitas"
                  @change="refreshData"
                >
                  <a-select-option v-for="option in options.entitas" :key="option.value">
                    {{ option.text }}
                  </a-select-option>
                </a-select>
              </a-col>

              <a-col :md="8" :sm="24" style="text-align: right;">
                <a-button class="btn-add_new" size="default" type="primary" @click="refreshData">
                  <template #icon><ReloadOutlined /></template>
                  Refresh Data
                </a-button>
                <a-button
                  class="btn-add_new"
                  size="default"
                  type="primary"
                  v-if="checkPermission('create kpi korporat')"
                  @click="handleAddClick"
                >
                  <template #icon><PlusOutlined /></template>
                  Tambah Perspektif
                </a-button>
              </a-col>
            </a-row>
          </sdCards>
        </a-col>
      </a-row>

      <!-- Kontrak Table Section -->
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <a-table
              :columns="kontrakColumns"
              :pagination="false"
              :dataSource="dataSource"
              :row-class-name="rowClassName"
              :scroll="{ x: 4000, y: 400 }"
              :loading="isLoading"
              bordered
            />
          </sdCards>
        </a-col>
      </a-row>
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { reactive, onMounted, computed, h } from 'vue';
import { useStore } from 'vuex';
import { Main } from '@/view/styled';
import { RecordViewWrapper } from '../../../components/crud/style';
import { getItem, setItem } from '@/utility/localStorageControl';
import { Modal, message, Space } from 'ant-design-vue';
import { useRouter, onBeforeRouteLeave } from 'vue-router';
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons-vue';
import axiosApi from '@/api';
import { getItemFlags, isMonthTargeted, formatNumber, targetValue } from '@/utility/kontrak/getItemFlags';
import { polarisasiIcon } from '@/utility/polarisasiUtils';
import { getTargetFlags } from '@/utility/kontrak/getTargetFlags';
import { getTargetTahunan } from '@/utility/kontrak/getTargetTahunan';

export default {
  name: 'NkoKontrak',
  components: {
    Main,
    RecordViewWrapper,
    ReloadOutlined,
    PlusOutlined,
  },
  setup() {
    const store = useStore();
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);
    const router = useRouter();
    const isLoading = computed(() => state.crud.loading);
    const profile = getItem('profile_plnbb');
    const permissions = getItem('permissions');
    const accessToken = getItem('access_token');
    const entitas = getItem('entitas');
    const tahun = getItem('tahun');

    // Filter options
    const currentYear = new Date().getFullYear();
    const tahunOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const filters = reactive({
      tahun: tahun ? tahun : currentYear,
      entitas: entitas ? entitas : null,
      title: 'Kontrak Kinerja Organisasi',
    });

    // Define label and wrapper column settings
    const labelCol = {
      lg: 6,
      md: 9,
      xs: 24,
    };

    const wrapperCol = {
      lg: 18,
      md: 15,
      xs: 24,
    };

    const options = reactive({
      entitas: [],
    });
    // Months for target columns
    const { months } = require('@/utility/monthsData');

    const numberFormat = new Intl.NumberFormat('id');

    // Table columns for kontrak
    const kontrakColumns = [
      {
        title: '#',
        dataIndex: 'number',
        key: 'number',
        width: 100,
        //fixed: 'left',
      },
      {
        title: 'Indikator Kinerja',
        dataIndex: 'name',
        key: 'name',
        width: 300,
        //fixed: 'left',
      },
      {
        title: '',
        // dataIndex: 'kpi_action',
        key: 'kpi_action',
        width: 150,
        customRender: ({ record }) => {
          console.log(record);
          const { create, update, del } = getItemFlags(record, profile, filters, checkPermission, handleDeleteKpi);
          return h(Space, { direction: 'horizontal', size: '0' }, [create, update, del]);
        },
      },
      {
        title: '',
        // dataIndex: 'polarisasi',
        key: 'polarisasi',
        width: 50,
        align: 'center',
        customRender: ({ record }) => {
          return polarisasiIcon(record.polarisasi);
        },
      },
      {
        title: 'Satuan',
        dataIndex: 'satuan_kpi_id',
        key: 'satuan_kpi_id',
        width: '70',
      },
      {
        title: 'Bobot',
        dataIndex: 'bobot',
        key: 'bobot',
        width: 150,
        align: 'center',
      },
      {
        title: 'Target KM',
        dataIndex: 'target_tahunan',
        key: 'target_tahunan',
        width: 150,
        align: 'center',
        customRender: ({ text }) => {
          return h('div', { style: { whiteSpace: 'pre-line' } }, text);
        },
      },
      // Month columns for realization
      {
        title: 'Target Bulanan',
        children: months
          .map(month => [
            {
              title: month.full,
              dataIndex: `target_${month.index}`,
              key: `target_${month.index}`,
              align: 'center',
              colSpan: 2,
              customHeader: true,
              width: 150,
              customRender: ({ text }) => {
                return h('div', { style: { whiteSpace: 'pre-line' } }, text);
              },
              customCell: record => {
                const isEmpty = record.starting_month > month.index;
                if (record.is_parent) {
                  return {
                    style: {
                      backgroundColor: '#FADA7A',
                    },
                  };
                }
                return {
                  style: {
                    backgroundColor: isEmpty ? '#f5f5f5' : '#FFFFFF',
                  },
                };
              },
            },
            {
              title: '',
              dataIndex: `target_action_${month.index}`,
              key: `target_action_${month.index}`,
              colSpan: 0,
              customHeader: true,
              width: '30',
              customCell: record => {
                const isEmpty = record.starting_month > month.index;
                if (record.is_parent) {
                  return {
                    padding: '12px 24px',
                    style: {
                      backgroundColor: '#FADA7A',
                    },
                  };
                }
                return {
                  padding: '12px 24px',
                  style: {
                    backgroundColor: isEmpty ? '#f5f5f5' : '#FFFFFF',
                  },
                };
              },
            },
          ])
          .flat(),
      },
      // ...months.map(month => ({
      //   title: month.short,
      //   dataIndex: `target_${month.value}`,
      //   key: `target_${month.value}`,
      //   align: 'right',
      // })),
    ];

    const checkPermission = permission => {
      if (profile.roles[0].name == 'Super Admin') {
        return true;
      }

      return permissions.includes(permission);
    };

    // Function to handle add button click
    const handleAddClick = () => {
      // Navigate to the add page with the selected tahun and entitas
      router.push(`/nko-kontrak-add/1/${filters.tahun}`);
    };

    // Function to refresh data
    const refreshData = () => {
      setItem('entitas', filters.entitas);
      setItem('tahun', filters.tahun);
      store.commit('axiosResetState');
      setTimeout(() => {
        getData(filters.entitas, filters.tahun);
      }, 100);
    };
    const totalBobot = computed(() => {
      return crud.value.reduce((total, data) => {
        if (data.is_parent) {
          return total;
        }
        return total + data.bobot;
      }, 0);
    });

    const dataSource = computed(() =>
      crud.value.length
        ? crud?.value?.map((data, key) => {
            const { createTarget, updateTarget, delTarget } = getTargetFlags(
              data,
              profile,
              filters,
              checkPermission,
              handleDeleteTarget,
            );

            // Use the extracted utility function
            const targetTahunanValue = getTargetTahunan(data);

            return {
              key: key + 1,
              id_kpi: data.id,
              number: data.number,
              name: data.name,
              editable: data.editable,
              starting_month: data.starting_month,
              polarisasi: data.polarisasi,
              satuan_kpi_id: data.satuan_kpi ? data.satuan_kpi['name'] : '',
              bobot: data.jenis_variable_kpi_id == 3 ? 'Max - ' + data.max_pengurang : numberFormat.format(data.bobot),
              target_tahunan: targetTahunanValue,
              is_parent: data.is_parent,
              ...(data.targets
                ? data.targets.reduce((acc, target) => {
                    const value = targetValue(target);
                    acc[`target_${target.month}`] = value;
                    acc[`target_action_${target.month}`] = (
                      <a-space direction="horizontal" size="0">
                        {updateTarget(target.id)}
                        {delTarget(target.id, data.name, target.month, filters.tahun, target.status)}
                        <a-space direction="vertical" size="0">
                          {target.status ? <a-tag color={target_color(target.status)}>{target.status}</a-tag> : ''}
                        </a-space>
                      </a-space>
                    );
                    return acc;
                  }, {})
                : {}),
              ...months.reduce((acc, month) => {
                // Only add action if: data.targets exists, month not already targeted, not parent, and month is after starting_month
                const shouldShowAction =
                  data.targets &&
                  !data.is_parent &&
                  !isMonthTargeted(data.targets, month.index) &&
                  data.starting_month <= month.index;
                if (shouldShowAction) {
                  acc[`target_action_${month.index}`] = (
                    <div class="table-actions">
                      {createTarget(data.id, month.index, filters.tahun, data.jenis_variable_kpi_id)}
                    </div>
                  );
                  //acc[`target_${month.index}`] = '';
                }
                return acc;
              }, {}),
            };
          })
        : [],
    );
    const { getStatusColor } = require('@/utility/status/statusColorMapping');
    const target_color = getStatusColor;

    const getData = (entitas_id, tahun) => {
      dispatch('axiosCrudGetData', 'list-kpi-korporat?month=1&year=' + tahun + '&entitas_id=' + entitas_id);
    };

    const handleDeleteTarget = (id, kpi_korporat, target_month, target_year) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus target ${kpi_korporat} ${
          months[target_month - 1].full
        } ${target_year}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'target-kpi-korporat',
            getData: () => {
              dispatch(
                'axiosCrudGetData',
                'list-kpi-korporat?month=' + target_month + '&year=' + target_year + '&entitas_id=' + entitas,
              );
            },
          });
        },
      });
    };

    const handleDeleteKpi = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin menghapus ${name}?`,
        okText: 'Hapus',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataDelete', {
            id,
            url: 'kpi-korporat',
            getData: () => {
              dispatch('axiosCrudGetData', 'list-kpi-korporat?month=1&year=' + tahun + '&entitas_id=' + entitas);
            },
          });
        },
      });
    };

    onMounted(() => {
      // Fetch entitas options directly from API
      axiosApi.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
      axiosApi
        .get('options-entitas')
        .then(response => {
          options.entitas = response.data;
        })
        .catch(error => {
          console.error('Error fetching entitas options:', error);
          message.error('Gagal mengambil data entitas');
        });
      if (entitas && tahun) {
        getData(entitas, tahun);
      }
    });

    onBeforeRouteLeave(() => {
      store.commit('axiosResetState');
    });

    const rowClassName = record => {
      if (record.is_parent) {
        return 'table-row-minor';
      } else {
        return '';
      }
    };

    return {
      options,
      filters,
      tahunOptions,
      kontrakColumns,
      dataSource,
      months,
      refreshData,
      isLoading,
      labelCol,
      wrapperCol,
      checkPermission,
      handleAddClick,
      target_color,
      handleDeleteTarget,
      rowClassName,
      totalBobot,
      isMonthTargeted,
      formatNumber,
      handleDeleteKpi,
    };
  },
};
</script>

<style scoped>
.custom-icon {
  margin-left: 10px;
  color: rgb(54, 61, 68);
}

::v-deep(.table-row-minor) {
  background-color: #fada7a;
  font-weight: bold;
  font-size: 14px;
}

::v-deep .ant-table-thead > tr > th {
  background-color: #578fca; /* navy */
  color: white;
}
</style>
